import { WelcomeScreen, LEAD_COLLECTOR_STEPS, Form, useFetchForm, VIEW_TYPE } from '@entities/leadCollector';
import { ChooseForm, CreateFormTemplate, CreateLinks } from '@widgets/leadCollector';
import { CreateForm } from '@features/leadCollector';
import { useEffect, useState } from 'react';
import { FormLink } from '@pages/event/api/useFetchEvent';

interface LeadCollectorTabProps {
  selectedForm?: Form;
  refetchEvent?: () => void;
  hasGeneratedLinks?: boolean;
  formLinks?: FormLink[] | null;
}

export const LeadCollectorTab = ({
  selectedForm,
  refetchEvent,
  hasGeneratedLinks,
  formLinks,
}: LeadCollectorTabProps) => {
  const [step, setStep] = useState(LEAD_COLLECTOR_STEPS.WELCOME);
  const [prevStep, setPrevStep] = useState(LEAD_COLLECTOR_STEPS.WELCOME);
  const [formId, setFormId] = useState(selectedForm?.id || '');
  const { form, refetch, fetching } = useFetchForm(Number(formId));
  const [viewType, setViewType] = useState(VIEW_TYPE.CONSTRUCTOR);

  useEffect(() => {
    if (selectedForm?.id) {
      setStep(LEAD_COLLECTOR_STEPS.CREATE_LINKS);
    }
  }, []);

  const onPreviewTemplate = (id?: string | number) => {
    if (!id) return;

    setViewType(VIEW_TYPE.PREVIEW_TEMPLATE);
    setFormId(id);
    setStep(LEAD_COLLECTOR_STEPS.CONSTRUCTOR_FORM);
  };

  switch (step) {
    case LEAD_COLLECTOR_STEPS.WELCOME:
      return <WelcomeScreen setStep={setStep} />;
    case LEAD_COLLECTOR_STEPS.CHOOSE_FORM:
      return (
        <ChooseForm
          setStep={setStep}
          hasGeneratedLinks={hasGeneratedLinks}
          setPrevStep={setPrevStep}
          onPreviewTemplate={onPreviewTemplate}
          selectedForm={selectedForm}
        />
      );
    case LEAD_COLLECTOR_STEPS.CREATE_FORM:
      return (
        <CreateForm
          setStep={setStep}
          prevStep={prevStep}
          setPrevStep={setPrevStep}
          setFormId={setFormId}
          setViewType={setViewType}
        />
      );
    case LEAD_COLLECTOR_STEPS.CONSTRUCTOR_FORM:
      return (
        <CreateFormTemplate
          viewType={viewType}
          setViewType={setViewType}
          setStep={setStep}
          form={fetching ? undefined : form}
          hasGeneratedLinks={!!hasGeneratedLinks}
          prevStepFromCreate={prevStep}
          refetchForm={refetch}
          isLoadingForm={fetching}
        />
      );
    case LEAD_COLLECTOR_STEPS.CREATE_LINKS:
      return (
        <CreateLinks
          setStep={setStep}
          form={selectedForm || form}
          refetchEvent={refetchEvent}
          hasGeneratedLinks={hasGeneratedLinks}
          setPrevStep={setPrevStep}
          onPreviewTemplate={onPreviewTemplate}
          formLinks={formLinks}
        />
      );
  }
};
